// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useRef } from "react";
import { MONITORING_DEFAULT_REFRESH_MS } from "./types";
import { usePageVisible } from "./usePageVisible";
/**
 * Asks for the dashboard every `intervalMs` (30 s by default) while the tab
 * is shown and nobody is editing. A tab shown again asks at once, rather than
 * showing figures that may be minutes old until the next tick.
 */
export function useMonitoringPolling(_a) {
    var active = _a.active, onPoll = _a.onPoll, _b = _a.intervalMs, intervalMs = _b === void 0 ? MONITORING_DEFAULT_REFRESH_MS : _b;
    var visible = usePageVisible();
    var latest = useRef(onPoll);
    latest.current = onPoll;
    var wasVisible = useRef(visible);
    useEffect(function () {
        var shownAgain = visible && !wasVisible.current;
        wasVisible.current = visible;
        if (!active || !visible)
            return;
        if (shownAgain)
            latest.current();
        var timer = window.setInterval(function () { return latest.current(); }, intervalMs);
        return function () { return window.clearInterval(timer); };
    }, [active, visible, intervalMs]);
}
